import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { WebCache } from "../services/WebCache";
import {UtilService} from '../services/UtilService';
import { IBranche, ILocation} from "../models/ITerminal";
import SelectField from './controls/fields/selectFieldNew';
import { OptionMapperHelper } from '../helpers/OptionMapperHelper';
import { Option } from 'react-multi-select-component';
import FilterFiscalDocumentAndCommerce from "./FilterFiscalDocumentAndCommerceNew";
import { FilterBlock } from './containers/form-filterNew';



type SlotType = "primary" | "advanced";

interface BaseFilterConfig {
  slot?: SlotType;
  primaryClass: string;
  advancedClass: string; 
}

interface TaxPayerFilterConfig extends BaseFilterConfig {
  value: string[]; // multiselecci�n
}

interface SingleValueFilterConfig extends BaseFilterConfig {
  value: string; // selecci�n �nica
}

interface FiltersConfig {
  taxPayerFilter: TaxPayerFilterConfig;
  branchFilter: SingleValueFilterConfig;
  departmentFilter: SingleValueFilterConfig;
  locationFilter: SingleValueFilterConfig;
//   fiscalDocument?:BaseFilterConfig;
  merchantDocument: BaseFilterConfig;
}

interface IProps {
  changeFilter: (
    taxPayerFilter: string[],
    branchFilter: string,
    departmentFilter: string,
    locationFilter: string,
    departmentName: string,
    locationName: string,
    branchName: string,
    clientDocument: string
  ) => void;
  onReady?: (instance: TerminalLocation) => void; // instance ref
  t: TFunction;
  filter: FiltersConfig;
}

interface IState {
    departmentFilter: string
    locationFilter: string
    branchFilter: string
    departmentName: string,
    locationName: string,
    branchName: string,
    taxPayerName: string,
    taxPayerId: string
    taxPayerFilter: string[],   
    currentPayerIds: Option[],
    render: boolean    
}

const allRecordsFilter = "0000";
class TerminalLocation extends React.Component<IProps, IState> {
    private currentLocations: ILocation[] = WebCache.getAllLocations();
    private currentBranches: IBranche[] = WebCache.getAllBranches();    
    private divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-sm-12 col-md-4 col-lg-3";
    private refMultiselect = React.createRef<any>();

    constructor(props: IProps) {  
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            departmentFilter: "",
            locationFilter: "",
            branchFilter: "",
            currentPayerIds: WebCache.getAllMerchantDocuments(true, false),
            departmentName: "",
            locationName: "",
            branchName: "",
            taxPayerId: "",
            taxPayerName: "",
            taxPayerFilter: [""] ,
            render: true           
        }
    }

    componentDidMount(): void {
        const translatedPayerIds = WebCache.getAllMerchantDocuments(true, true)
            .map(doc => { return { ...doc, label: this.props.t(doc.label) }; });
        this.setState({ ...this.state, currentPayerIds: translatedPayerIds });
        this.props.onReady?.(this); // ← el hijo entrega su instancia al padre
    }

    optionSelected(selected: any) {
        this.setState((prevState) => ({
            ...prevState,
            taxPayerFilter: selected
        }));
        this.props.changeFilter(selected, this.state.branchFilter, this.state.departmentFilter, this.state.locationFilter, this.state.departmentName, this.state.locationName, this.state.branchName, this.state.taxPayerName);
    }

   
    componentDidUpdate(prevProps: IProps): void {
    const { filter } = this.props;

    // 1) Actualizar state si cambian los valores
    if (
        prevProps.filter.taxPayerFilter.value !== filter.taxPayerFilter.value ||
        prevProps.filter.branchFilter.value !== filter.branchFilter.value ||
        prevProps.filter.departmentFilter.value !== filter.departmentFilter.value ||
        prevProps.filter.locationFilter.value !== filter.locationFilter.value
    ) {
        this.setState({
        taxPayerFilter: filter.taxPayerFilter.value ?? [""],
        branchFilter: filter.branchFilter.value ?? " ",
        departmentFilter: filter.departmentFilter.value ?? " ",
        locationFilter: filter.locationFilter.value ?? " ",
        });
    }

    // 2) Reset masivo si todos los props est�n vac�os
    const allEmpty =
        (filter.branchFilter.value === " ") &&
        (filter.locationFilter.value === " ") &&
        (filter.departmentFilter.value === " ") &&
        (filter.taxPayerFilter.value.length === 0);

    if (allEmpty) {
        this.setState({
        taxPayerFilter: [],
        branchFilter: " ",
        departmentFilter: " ",
        locationFilter: " ",
        });
    }
    }

    handleChange(event: any) {
        const targetId = event.target.id;
        const targetValue = event.target.value;
        let taxPayerIds = WebCache.getAllMerchantDocuments(true, true);
        let branchName = "";
        let locationName = "";
        let departmentName = "";
        let branches = WebCache.getAllBranches();        
        let departments = WebCache.getAllDepartments();
        let terminals = WebCache.getAllTerminals();

        switch (true) {
            case targetId.includes("taxPayerFilter"):
                /* taxPayerIdName = targetValue === '' ? this.state.currentPayerIds[0].label : targetValue;
                this.setState({ ...this.state, taxPayerFilter: targetValue, taxPayerName: taxPayerIdName });
                this.props.changeFilter(targetValue, this.state.branchFilter, this.state.departmentFilter, this.state.locationFilter, this.state.departmentName, this.state.locationName, this.state.branchName, taxPayerIdName);
                 */
                break;

            case targetId.includes("branchFilter"):
                const branch = branches.find(dep => dep.id === targetValue);
                branchName = branch ? branch.name : ""
                
                if (targetValue !== allRecordsFilter){
                    const filteredPayerIds = taxPayerIds.filter(payerId =>
                        terminals.some(t => t.clientDocument === payerId.value && t.branchName === branchName)
                    ).map(payerId => ({
                        value: payerId.value,
                        label: payerId.value,
                        key: payerId.key,
                        disabled: payerId.disabled
                    }));
                    //This correctly filters the client documents by branch name, but the "changeFilter" function doesn't update the information.
                    this.setState({ ...this.state, branchFilter: targetValue, branchName, currentPayerIds: filteredPayerIds, taxPayerName: "", taxPayerId: "" });                    
                } else {
                    this.setState({ ...this.state, 
                        branchFilter: "", 
                        branchName, 
                        currentPayerIds: taxPayerIds, 
                        taxPayerName: "", 
                        taxPayerId: "" });
                }               

                this.props.changeFilter([""], targetValue, this.state.departmentFilter, this.state.locationFilter, this.state.departmentName, this.state.locationName, branchName, "");
                break;

            case targetId.includes("locationFilter"):
                this.currentBranches = WebCache.getAllBranches();
                const location = this.currentLocations.find(dep => dep.id === targetValue);
                
                if (targetValue !== allRecordsFilter) {
                    locationName = location ? location.name : "";
                    
                    const filteredPayerIds = taxPayerIds.filter(payerId =>
                        WebCache.getAllTerminals().some(t => t.clientDocument === payerId.value && t.locationName === locationName)
                    ).map(payerId => ({
                        value: payerId.value,
                        label: payerId.value,
                        key: payerId.key,
                        disabled: payerId.disabled
                    }));                    
                    this.currentBranches = WebCache.getAllBranches().filter(l => l.locationId === targetValue);
                    this.currentBranches = [WebCache.getAllBranches()[0], ...this.currentBranches];
                    this.setState({...this.state, 
                                currentPayerIds: filteredPayerIds,
                                render: !this.state.render});
                    
                } else {
                    //Setea todos los filtros por default cuando no se selecciono un filtro especifico.
                    this.setState({
                        ...this.state,
                        locationFilter: "",
                        branchFilter: "",
                        branchName: "",
                        taxPayerId: "",
                        currentPayerIds: taxPayerIds,
                        taxPayerName: "",
                        locationName
                    });
                }
                
                this.props.changeFilter([this.state.taxPayerId], 
                                        this.state.branchFilter, 
                                        this.state.departmentFilter, targetValue, this.state.departmentName, locationName, "", "");
                break;

            case targetId.includes("departmentFilter"):
                this.currentLocations = WebCache.getAllLocations();
                this.currentBranches = WebCache.getAllBranches();
                const department = departments.find(dep => dep.id === targetValue);
                
                if (targetValue !== allRecordsFilter) {
                    departmentName = department ? department.name : "";
                    const filteredPayerIds = taxPayerIds.filter(payerId =>
                        terminals.some(t => t.clientDocument === payerId.value && t.departmentName === departmentName)
                    ).map(payerId => ({
                        value: payerId.value,
                        label: payerId.value,
                        key: payerId.key,
                        disabled: payerId.disabled
                    }));                       
                        this.currentLocations = WebCache.getAllLocations().filter(l => l.departmentId === targetValue);
                        this.currentLocations = [WebCache.getAllLocations()[0], ...this.currentLocations];
                        
                        this.currentBranches = WebCache.getAllBranches().filter(l => l.departmentId === targetValue);
                        this.currentBranches = [WebCache.getAllBranches()[0], ...this.currentBranches];
                        this.setState({...this.state, 
                            currentPayerIds: filteredPayerIds,
                            render: !this.state.render});                    
                }
                else {                   
                    this.setState({
                        ...this.state,
                        departmentFilter: "",
                        locationFilter: "",
                        //currentLocations: locations,
                        locationName: "",
                        branchFilter: "",
                        //currentBranches: branches,
                        branchName: "",
                        taxPayerId: "",
                        currentPayerIds: taxPayerIds,
                        taxPayerName: "",
                        departmentName,
                        render: !this.state.render
                    });                    
                }
                this.props.changeFilter([""], "", targetValue, "", departmentName, "", "", "");
                break;
            default:
                break;
        }
    }

    clearFilters() {
        this.setState({
            departmentFilter: "",
            locationFilter: "",
            branchFilter: "",
            departmentName: "",
            locationName: "",
            branchName: "",
            taxPayerId: "",
            taxPayerName: "",
            taxPayerFilter: [""],
            currentPayerIds: WebCache.getAllMerchantDocuments(true, false),
            render: !this.state.render
        });
        this.refMultiselect?.current?.clearFilters();
    }

    buildSelectOptionsFromIdName(options: Array<{ id: string, name: string }>) {
        return new OptionMapperHelper(this.props.t).buildSelectOptionsFromAnArrayWithDifferentInterface(options, 'id', 'name');
    }

    render() {
        return ( 
            <React.Fragment>
                <FilterBlock slot={this.props.filter.departmentFilter.slot} primaryClass={this.props.filter.departmentFilter.primaryClass} advancedClass={this.props.filter.departmentFilter.advancedClass}>
                    <SelectField model={[ this.state, this.setState.bind(this) ]} attr='departmentFilter' label={WebCache.isUserUYU() ? 'department':'departmentArg'} options={this.buildSelectOptionsFromIdName(WebCache.getAllDepartments())} onChange={(e)=> this.handleChange(e)}></SelectField>
                </FilterBlock>
                <FilterBlock slot={this.props.filter.locationFilter.slot} primaryClass={this.props.filter.locationFilter.primaryClass} advancedClass={this.props.filter.locationFilter.advancedClass}>
                    <SelectField model={[this.state, this.setState.bind(this)]} attr='locationFilter' label='location' options={this.buildSelectOptionsFromIdName(this.currentLocations)} onChange={(e)=> this.handleChange(e)}></SelectField>
                </FilterBlock>
                <FilterBlock slot={this.props.filter.branchFilter.slot} primaryClass={this.props.filter.branchFilter.primaryClass} advancedClass={this.props.filter.branchFilter.advancedClass}>
                    <SelectField model={[this.state, this.setState.bind(this)]} attr='branchFilter' label='branch' options={this.buildSelectOptionsFromIdName(this.currentBranches)} onChange={(e)=> this.handleChange(e)} ></SelectField>
                </FilterBlock>
                <FilterFiscalDocumentAndCommerce
                    ref={this.refMultiselect}
                    merchantDocumentConfig={this.props.filter.merchantDocument}
                    fiscalDocumentConfig={{
                        primaryClass: this.props.filter.taxPayerFilter.primaryClass,
                        advancedClass: this.props.filter.taxPayerFilter.advancedClass,
                        slot: this.props.filter.taxPayerFilter.slot
                    }}
                    changeFilter={(fiscalDocument, merchantNumber)=>{
                        this.optionSelected(fiscalDocument);
                    }}
                    includeAllFiscalDocument={true}
                    hideMerchants={true}
                    includeWholesaler={false}
                />
            </React.Fragment>
        )
    };
}

export type TerminalLocationRef = TerminalLocation;
export default withTranslation()(TerminalLocation);